export default __webpack_public_path__ + "static/media/streak 77 badge.a63837c8.svg";